<template>
  <div class="form">
    <div class="form__header">
      <h3>Задание</h3>
    </div>

    <div class="form__body task">
      <p class="form__filed">
        {{ data.description }}
      </p>
      <div class="form__field">
        <div uk-lightbox v-if="data.image">
          <a :href="data.image"><img :src="data.image" alt="Изображение"></a>
        </div>        
      </div>
      <Input 
        class="form__field"
        v-model="answer" 
        label="Ваш ответ" 
        type="text" 
        id="answer" 
        :required="true"
        :readonly="data.is_done ? true : false"
      />
      <span v-show="data.is_done">Правильный ответ: {{ data.answer }}</span>
    </div>

    <div class="form__footer" v-show="!data.is_done">
      <SubmitButton @submit="sendForm" :isValid="answer"/>
    </div>
  </div>
</template>

<script>
import { form_mix } from '../../../mixins/form_mix'
export default {
  mixins: [ form_mix ],
  props: ['data', 'student_id', 'team_id', 'task_id'],
  inject: ['http'],
  data() {
    return {
      answer: null
    }
  },
  methods: {
    sendForm() {
      let path = 'onSaveMatriusAnswer'
      let data = {
        task_id: this.data.id,
        answer: this.answer.toLowerCase(),
        student_id: this.student_id,
      }
      if (this.task_id) {
        data.id = this.task_id
      }

      if (this.team_id) {
        data.team_id = this.team_id
      }

      this.http.post(path, data).then(res => {
        let completed = {
          answer: data.answer,
          is_right: res.data.is_right,
          is_done: true,
          id: this.task_id
        }
        this.$emit('close-popup')
        this.$emit('complete-task', completed)

        if (res.data.is_right) {
          swal('Верно!', '', 'success')
        } else {
          swal('Неверно!', '', 'error')
        }
      })
    }
  },
  created() {
    if (this.data.is_done) {
      this.answer = this.data.user_answer
    }
    console.log(this.data)
  }
}
</script>

<style lang="scss" scoped>
.task__image {
  width: 100%;
}
</style>

